/**
 * Shared types and constants for the criterion inline form
 * used across add-row, edit-row, and the form state hook.
 */

export interface CriterionFormValues {
	name: string;
	description: string;
	rfx_evaluation_type_id: number;
	weight: string;
}

export const EMPTY_FORM: CriterionFormValues = {
	name: "",
	description: "",
	rfx_evaluation_type_id: 2,
	weight: "",
};
